import React, { useState } from 'react';
import {
  TopToolbar,
  CreateButton,
  Button,
} from 'react-admin';
import FileUploadIcon from '@mui/icons-material/FileUpload';

import type { PricingType } from './types';
import PricingRulesImportDialog from './PricingRulesImportDialog';

interface PricingRulesActionsProps {
  pricingType: PricingType;
}

const PricingRulesActions = ({ pricingType }: PricingRulesActionsProps) => {
  const [isImportDialogOpen, setIsImportDialogOpen] = useState(false);

  return (
    <TopToolbar>
      <CreateButton />
      <Button
        label="Import"
        onClick={() => setIsImportDialogOpen(true)}
        startIcon={<FileUploadIcon />}
      />
      <PricingRulesImportDialog
        open={isImportDialogOpen}
        onClose={() => setIsImportDialogOpen(false)}
        pricingType={pricingType}
      />
    </TopToolbar>
  );
};

export default PricingRulesActions;
